<template>
    <NuxtLayout name="malt-base-layout">
        <main>
            <slot />
        </main>
    </NuxtLayout>
</template>
